export const FIELD_EMAIL = "email";
export const FIELD_PASSWORD = "password";
export const FIELD_REPEAT_PASSWORD = "repeat-password";
export const FIELD_NAME = "name";
export const FIELD_GENDER = "gender";
export const FIELD_WEIGHT = "weight";
export const FIELD_PLATFORM = "platform";
export const FIELD_INVITE_CODE = "invite-code";
